import { Tooltip } from "radix-ui";
import type { ReactNode } from "react";
import { MediaContext, type MediaResolver } from "./media.tsx";

/**
 * Mount once at the app root (tooltip timing shared by IconButton / hover actions). `media`: how Image, Video,
 * DocumentView and MediaViewer load file URLs (the platform's authenticated media pipeline).
 */
export function PrimitivesProvider({ children, media }: { children: ReactNode; media?: MediaResolver }) {
  const tree = <Tooltip.Provider delayDuration={500} skipDelayDuration={200}>{children}</Tooltip.Provider>;
  return media === undefined ? tree : <MediaContext.Provider value={media}>{tree}</MediaContext.Provider>;
}
